<template>
  <div>
    <div id="google_translate_element"></div>
    <div v-if="translateType === 'auto'" class="poweredby">
      <a class="goog-logo-link" href="https://translate.google.com" target="_blank">
        <img src="~@/assets/img/logo_google_translate.png" alt="powered by google translate" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Translate',
  props: [
    'lang'
  ],
  computed: {
    alwaysAutoTranslate () {
      return !!this.$route.meta.translate && this.$route.meta.translate === 'always'
    },
    ln () {
      return this.$route.params.ln
    },
    langData () {
      return this.$store.getters['common/getSetting'].lang.usableList
    },
    defaultLang () {
      return this.$store.getters['common/getSetting'].lang.default
    },
    translateReady () {
      return this.$store.getters.translateReady !== null
    },
    translateRestore () {
      return this.$store.getters.translateRestore
    },
    translateType () {
      return this.$store.getters.translate
    }
  },
  watch: {
    ln (ln) {
      this.translateInit()
    },
    translateRestore (isRestore) {
      if (isRestore) {
        const iframe = document.querySelector('.skiptranslate iframe')
        if (iframe) {
          const iframeShow = document.querySelector('div.skiptranslate').style.display
          if (iframeShow !== 'none') {
            const cancelAutoTranslate = iframe.contentWindow.document.getElementById(':1.cancel')
            const resetAutoTranslate = iframe.contentWindow.document.getElementById(':1.restore')
            this.fireEvent(cancelAutoTranslate, 'click')
            this.fireEvent(resetAutoTranslate, 'click')
          }
        }
      }
    }
  },
  mounted () {
    setTimeout(() => {
      window.addEventListener('onload', this.init())
    }, 100)
  },
  data () {
    return {
      intervalManual: '',
      intervalAuto: ''
    }
  },
  methods: {
    async init () {
      await this.googleTranslateElementInit()
      this.translateInit()
    },
    setTranslateCookie (source, target) {
      document.cookie = `googtrans=/${source}/${target}`
    },
    translateInit () {
      // 기본언어를 포함한 수동번역 설정시 직접 입력한 컨텐츠로 제공
      if (this.translateType === 'manual' && !this.alwaysAutoTranslate) {
        clearInterval(this.intervalAuto)
        this.translateManual()
      } else {
        /**
         * 자동번역 처리 조건
         * 페이지:: 자동번역 언어일 때
         * 자체제공 서비스(지역정보, 쿠폰함)에서 기본언어가 아닐 때
         */
        if (this.ln === this.defaultLang) {
          clearInterval(this.intervalAuto)
          this.translateManual()
        } else {
          // 위 조건을 제외하고 모두 자동번역 처리
          clearInterval(this.intervalManual)
          this.translateAuto()
        }
      }
    },
    /**
     * 구글 인스턴스 생성
     * Google 번역은 'googtrans' 쿠키로 출발어를 추적하므로
     * 라우터에서 출발어/도착어를 미리 설정
     */
    googleTranslateElementInit () {
      const source = this.defaultLang
      const target = this.ln
      this.setTranslateCookie(source, target)
      return new Promise((resolve) => {
        new google.translate.TranslateElement({ pageLanguage: source }, 'google_translate_element')
        resolve()
      })
    },
    // 이벤트 트리거 (change translate or click init)
    fireEvent (element, eventName) {
      let event
      if (document.createEvent) {
        event = document.createEvent('HTMLEvents')
        event.initEvent(eventName, true, true)
        if (element) element.dispatchEvent(event)
      } else {
        event = document.createEventObject()
        event.eventType = eventName
        if (element) element.fireEvent('on' + event.eventType, event)
      }
    },
    /**
     * manual:: 수동번역
     * google translate restore trigger
     */
    translateManual: function () {
      const lang = this.ln
      this.intervalManual = setInterval(() => {
        const iframe = document.querySelector('.skiptranslate iframe')
        if (iframe) {
          const iframeShow = document.querySelector('div.skiptranslate').style.display
          if (iframeShow !== 'none') {
            const cancelAutoTranslate = iframe.contentWindow.document.getElementById(':1.cancel')
            const resetAutoTranslate = iframe.contentWindow.document.getElementById(':1.restore')
            this.fireEvent(cancelAutoTranslate, 'click')
            this.fireEvent(resetAutoTranslate, 'click')
            this.$store.dispatch('common/setDocsLang', lang)
            clearInterval(this.intervalManual)
          }
        }
      }, 500)
    },
    /**
     * auto:: 자동번역
     * google translate goog-te-combo trigger
     * 국가코드를 value로 선택
     */
    translateAuto: function () {
      this.intervalAuto = setInterval(() => {
        const googleAutoTranslate = document.querySelector('.goog-te-combo')
        if (googleAutoTranslate) {
          googleAutoTranslate.value = this.ln
          this.fireEvent(googleAutoTranslate, 'change')
          clearInterval(this.intervalAuto)
        }
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.poweredby {
  padding: 0.2em;
  text-align: center;
  background-color: $bg-default;
  img {
    height: 14px;
  }
}
</style>
